"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Node_1 = __importDefault(require("./Node"));

var Embed = /*#__PURE__*/function (_Node_1$default) {
  _inherits(Embed, _Node_1$default);

  var _super = _createSuper(Embed);

  function Embed() {
    _classCallCheck(this, Embed);

    return _super.apply(this, arguments);
  }

  _createClass(Embed, [{
    key: "component",
    value: function component(_ref) {
      var isEditable = _ref.isEditable,
          isSelected = _ref.isSelected,
          theme = _ref.theme,
          node = _ref.node;
      var Component = node.attrs.component;
      return React.createElement(Component, {
        attrs: node.attrs,
        isEditable: isEditable,
        isSelected: isSelected,
        theme: theme
      });
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return function (attrs) {
        return function (state, dispatch) {
          dispatch(state.tr.replaceSelectionWith(type.create(attrs)).scrollIntoView());
          return true;
        };
      };
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.ensureNewLine();
      state.write("[" + state.esc(node.attrs.href) + "](" + state.esc(node.attrs.href) + ")");
      state.write("\n\n");
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        node: "embed",
        getAttrs: function getAttrs(token) {
          return {
            href: token.attrGet("href"),
            matches: token.attrGet("matches"),
            component: token.attrGet("component")
          };
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "embed";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: "inline*",
        group: "block",
        atom: true,
        attrs: {
          href: {},
          component: {},
          matches: {}
        },
        parseDOM: [{
          tag: "iframe"
        }],
        toDOM: function toDOM(node) {
          return ["iframe", {
            src: node.attrs.href,
            contentEditable: false
          }, 0];
        }
      };
    }
  }]);

  return Embed;
}(Node_1.default);

exports.default = Embed;